import Vue from "vue";
import * as firebase from "firebase";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { firebaseConfig } from "./firebaseConfig";
import { ApolloClient } from "apollo-boost";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import VueApollo from "vue-apollo";
import { setContext } from "apollo-link-context";
import { createProvider } from "./vue-apollo";

Vue.use(VueApollo);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from ApplicationSettings if it exists
  // const token = ApplicationSettings.getString("token");
  let token = JSON.parse(localStorage.getItem("apollo-token"));
  // return the headers to the context so HTTP link can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null
    }
  };
});

const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: "https://fine-molly-41.hasura.app/v1/graphql",
  headers: authLink
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: "loading"
  }
});

Vue.config.productionTip = false;
// console.log(config);
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  provide: apolloProvider.provide(),
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
